<template>
    <div class="activityList">
        <div class="activityItem" v-for="item in dataSources" :key="item.activity_id" @click="activeDetail(item)">
            <div class="activityImg">
                <!--//1未开始 2进行中 3已结束-->
                <img :src="item.activity_cover" alt="">
                <span :class="[item.activity_status == 2 ? 'ingState' : '']">{{ activeState(item) }}</span>
            </div>
            <div class="activityContent">
                <div class="activityTitle">
                    <span>{{ item.activity_name }}</span>
                </div>
                <div class="activityTime">
                    <span>{{ item.start_time }} ~ {{ item.end_time }}</span>
                </div>
                <!--
                    button_state = 1;//显示:立即参与 
                    button_state = 2;//显示:上课签到(置灰)
                    button_state = 3;//显示:上课签到
                    button_state = 4;//显示:下课签到
                    button_state = 5;//显示:完成当日签到(纯文字)
                    button_state = 6;//显示:满意度评价
                    button_state = 7;//显示:查看评价
                    button_state = 8;//显示:(不展示按钮)
                -->
                <div v-if="item.button_state == 1 || item.button_state == 3 || item.button_state == 2 || item.button_state == 4 || item.button_state == 6"
                    :class="[item.button_state == 2 ? 'disableBtn' : 'activityBtn']" @click.stop="activeBtnClick(item)">
                    <span>{{ setStateString(item) }}</span>
                </div>

                <div v-if="item.button_state == 5" class="singedBtn">
                    <span>完成当日签到</span>
                </div>
                <div v-if="item.button_state == 7" @click.stop="evaluateBtnClick(item)" class="evaluateBtn">
                    <span>查看评价</span>
                </div>
            </div>
        </div>

        <div slot="empty" v-if="!dataSources.length">
            <div class="empty-tip">
                <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/tp-zwsj%402x.png" alt="">
                <span>暂无数据</span>
            </div>
        </div>


        <van-overlay :show="show" @click="show = false">
            <div class="wrapper" @click.stop>
                <div class="block">
                    <div v-if="showType == 3" class="blockTitle">
                        我已确认到达上课地点
                    </div>
                    <div v-if="showType == 3" class="blockTitle">
                        立即上课签到
                    </div>

                    <div v-if="showType == 4" class="blockTitle">
                        下课啦！
                    </div>
                    <div v-if="showType == 4" class="blockTitle">
                        立即下课签到
                    </div>

                    <div class="singBtn" @click="singClick">
                        签到
                    </div>

                </div>
            </div>
        </van-overlay>
    </div>
</template>
<script>
export default {
    props: {
        type: {
            type: Number,
            default: 1
        }
    },
    name: 'activityList',
    data() {
        return {
            showTitle: '',
            show: false,
            selectItem: {},
            showType: '',
            dataSources: [],
            paging: {                //翻页
                params: {
                    pageNum: 1,
                    pageSize: 10
                },
                total: null
            },

        };
    },
    mounted() {
        this.getData();

    },
    created() {
    },
    methods: {
        singClick() {
            if (this.showType == 3) {
                // let idAuthStatus = this.$store.state.userInfo.idAuthStatus
                // console.log(idAuthStatus,'idAuthStatusidAuthStatus');
                // if (idAuthStatus == 0) {
                //     this.$toast('请先实名认证');
                //     this.$router.push({
                //         path: '/idcard'
                //     });
                //     return;
                // }
                this.startSign();
            } else if (this.showType == 4) {
                this.endSign();
            }
        },
        activeDetail(item) {
            this.$router.push({
                path: '/activity/detail',
                query: {
                    activity_id: item.activity_id
                }
            });
        },
        // 下课签到
        endSign() {
            this.$api.homePage.endSign({
                activity_id: this.selectItem.activity_id
            }).then(res => {
                if (res.success) {
                    this.$message.success('签到成功');
                    this.selectItem = {};
                    this.show = false;
                    this.showType = '';
                    this.getData();
                }
            });
        },
        // 上课签到
        startSign() {
            this.$api.homePage.startSign({
                activity_id: this.selectItem.activity_id
            }).then(res => {
                if (res.success) {
                    this.$message.success('签到成功');
                    this.selectItem = {};
                    this.show = false;
                    this.showType = '';
                    this.getData();
                }
            });
        },
        // 立即参与
        singIn(item) {
            this.$api.homePage.joinActivity({
                activity_id: item.activity_id
            }).then(res => {
                if (res.success) {
                    this.$message.success('签到成功');
                    this.getData();
                }
            });
        },
        // 点击详情
        activeBtnClick(item) {
            if (item.button_state == 1) {
                // 立即参与
                this.singIn(item)
            } else if (item.button_state == 3) {
                this.show = true;
                this.showType = item.button_state;
                this.selectItem = item;
                // this.startSign(item);
            } else if (item.button_state == 4) {
                this.show = true;
                this.showType = item.button_state;
                this.selectItem = item;
                // this.endSign(item);
            } else if (item.button_state == 6) {
                // 满意度评价
                this.$router.push({
                    path: '/activity/evaluatePage',
                    query: {
                        activity_id: item.activity_id,
                        isEdit: 1
                    }
                });
            }
        },
        // 查看评价
        evaluateBtnClick(item) {
            // 查看满意度评价
            this.$router.push({
                path: '/activity/evaluatePage',
                query: {
                    activity_id: item.activity_id,
                    isEdit: 0
                }
            });

        },
        activeState(item) {
            if (item.activity_status == 1) {
                return '未开始';
            } else if (item.activity_status == 2) {
                return '进行中';
            } else if (item.activity_status == 3) {
                return '已结束';
            }
        },
        setStateString(item) {
            /*
                    button_state = 1;//显示:立即参与 
                    button_state = 2;//显示:上课签到(置灰)
                    button_state = 3;//显示:上课签到
                    button_state = 4;//显示:下课签到
                    button_state = 5;//显示:完成当日签到(纯文字)
                    button_state = 6;//显示:满意度评价
                    button_state = 7;//显示:查看评价
                    button_state = 8;//显示:(不展示按钮)
            */
            if (item.button_state == 1) {
                return '立即参与';
            } else if (item.button_state == 2) {
                return '上课签到';
            } else if (item.button_state == 3) {
                return '上课签到';
            } else if (item.button_state == 4) {
                return '下课签到';
            } else if (item.button_state == 5) {
                return '完成当日签到';
            } else if (item.button_state == 6) {
                return '满意度评价';
            } else if (item.button_state == 7) {
                return '查看评价';
            } else if (item.button_state == 8) {
                return '';
            }

        },
        async getData() {
            if (this.type == 1) {
                const res = await this.$api.homePage.activeList();
                if (res.success) {
                    this.dataSources = res.data;
                }
            } else if (this.type == 2) {
                const res = await this.$api.learningPage.activeList();
                if (res.success) {
                    this.dataSources = res.data;
                }
            }
        }
    },
};
</script>

<style scoped lang="stylus">
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 570px;
    height: 294px;
    background: #FEFFFE;
    border-radius: 24px;
    border: 3px solid #FFFFFF;
    display flex;
    flex-direction column;
    align-items center;
    justify-content center;
    .blockTitle{
        min-width: 320px;
        height: 48px;
        font-size: 32px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 48px;
        text-align: center;
    }
    .singBtn{
        width: 230px;
        height: 78px;
        background: linear-gradient(164deg, #5EC9FF 0%, #498BFD 100%);
        border-radius: 39px;
        font-size: 32px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 78px;
        text-align: center;
        margin-top: 24px;
    }
  }
.activityList{
    .activityItem{
        width 638px
        height 175px
        border-bottom: 1px solid #F0F0F0;
        display flex
        align-items center
        margin-bottom: 24px;
        .activityImg{
            width: 200px;
            height: 150px;
            border-radius: 20px;
            position relative;
            img{
                width: 200px;
                height: 150px;
                border-radius: 20px;
            }
            span{
                position absolute;
                top 0;
                left 0;
                width 84px;
                height: 36px;
                background: #EEEEEE;
                border-radius: 16px 0px 16px 0px;
                font-size: 20px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 36px;
                text-align: center;
            }
            .ingState{
                background: #FB750A;
                color: #FFFFFF;
            }
        }
        .activityContent{
            flex: 1
            padding-left: 24px;
            flex-direction: column;
            display: flex;
            .activityTitle{
                height: 28px;
                font-size: 28px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 28px;
                margin-bottom: 16px;
                overflow hidden
                text-overflow ellipsis
                white-space nowrap
                width 420px
                }
            .activityTime{
                height: 24px;
                font-size: 24px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #999999;
                line-height: 24px;
                margin-bottom: 24px;
                letter-spacing: 1px;
            }
            .activityBtn{
                width: 134px;
                height: 56px;
                background: linear-gradient(164deg, #5EC9FF 0%, #498BFD 100%);
                border-radius: 28px;
                line-height: 56px;
                font-size: 22px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
                text-align: center;
                align-self: flex-end;

        }
        }


    }

}

.disableBtn{
    width: 134px;
    height: 56px;
    background: #F3F3F3;
    border-radius: 28px;
    font-size: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 56px;
    text-align: center;
    align-self: flex-end;
}
.singedBtn{
    min-width: 132px;
    height: 26px;
    font-size: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #498BFD;
    line-height: 26px;
    text-align: center;
    align-self: flex-end;
}
.evaluateBtn{
    width: 133px;
    height: 56px;
    background: #FFE8C4;
    border-radius: 28px;
    border: 1px solid #FB750A;
    font-size: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #FB750A;
    line-height: 56px;
    text-align: center;
    align-self: flex-end;
}

.empty-tip
    min-height: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 32px;
    color: #D9DEE7;
    margin-top: 200px;
    padding-bottom: 30px;
    & img
        width: 200px;



</style>
